import apiAgent from "@/app/api/apiAgent";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/app/common/common-components/ui/Select";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

type StageDropdownProps = {
  type: "deal" | "contact";
  officeId: string;
  pipeLineId: string;
  stageId: string;
  onStageIdChange: (stageId: string) => void;
  disabled?: boolean;
  placeholder?: string;
};

const StageDropdown = ({ type, officeId, pipeLineId, stageId, onStageIdChange, disabled, placeholder }: StageDropdownProps) => {
  const { data: pipelines, isLoading } = useQuery({
    queryKey: ["pipelines-dropdown", officeId],
    queryFn: () => apiAgent.Pipeline.getPipelines(type, officeId),
  });

  const pipeline = pipelines?.find((p) => p.pipeline_id === pipeLineId);

  const stages = pipeline?.milestone;

  const isDisabled = !pipeline || !stages || stages.length === 0 || isLoading || disabled;

  useEffect(() => {
    if (!!pipeLineId && pipeLineId.length > 0 && !isLoading && !stages?.find((s) => s.milestone_id === stageId)) {
      onStageIdChange("");
    }
  }, [pipeLineId]);

  return (
    <Select value={stageId} onValueChange={(value) => !isDisabled && onStageIdChange(value)} disabled={isDisabled}>
      <SelectTrigger disabled={isDisabled}>
        <SelectValue placeholder={placeholder || "Select stage"} />
      </SelectTrigger>
      <SelectContent>
        {stages?.map((stage) => (
          <SelectItem key={stage.milestone_id} value={stage.milestone_id}>
            {stage.milestone_name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default StageDropdown;
